import { render, staticRenderFns } from "./comment-editor.vue?vue&type=template&id=1f5f5368&"
import script from "./comment-editor.vue?vue&type=script&lang=js&"
export * from "./comment-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports